(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/trustpilot-business-reviews
 * -----------------------------------------------------------------------------
 * @version 0.0.3
 * @copyright 2023 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
 * @param data-business-name {String}
 * @param data-api-key {String}
 * @param [data-page-limit=20] {Integer}
 * @param [data-filter-tag-value] {String}
 * @param [data-order-by] {String}
 * -----------------------------------------------------------------------------
 * See https://documentation-apidocumentation.trustpilot.com
 * -----------------------------------------------------------------------------
*/ if (customElements.get("trustpilot-business-reviews") === undefined) {
    class TruspilotBusinessReviews extends HTMLElement {
        constructor(){
            super();
            this.businessName = this.dataset.businessName;
            this.apiKey = this.dataset.apiKey;
            this.pageLimit = this.dataset.pageLimit || 20;
            this.locale = Shopify.locale || "en";
            this.summary = this.querySelector("[data-summary]");
            this.template = this.querySelector("template");
            this.reviewList = this.querySelector("[data-review-list]") || this;
            // Optional params
            this.tagValue = this.dataset.filterTagValue ? `&tagValue=${this.dataset.filterTagValue}` : "";
            this.orderBy = this.dataset.orderBy ? `&orderBy=${this.dataset.orderBy}` : "";
            this.valid = this.businessName && this.apiKey && this.template;
            this.valid ? this.fetchBusiness() : this.errorHandler();
        }
        async fetchBusiness() {
            this.businessUnit = await fetch(`https://api.trustpilot.com/v1/business-units/find?name=${this.businessName}&apikey=${this.apiKey}`).then((response)=>response.text()).then((responseText)=>{
                return JSON.parse(responseText);
            }).catch((error1)=>this.errorHandler(error1));
            this.businessUnit ? this.fetchData() : this.errorHandler();
        }
        fetchData() {
            if (this.summary) this.displaySummary();
            this.fetchReviews();
        }
        // TODO
        displaySummary() {
            const trustScore = Math.round(this.businessUnit.score.trustScore);
            const stars = this.renderStars(trustScore);
            if (stars) this.summary.querySelector("[data-stars]").innerHTML = stars;
            if (!this.businessUnit.score.trustScore || !this.businessUnit.numberOfReviews.usedForTrustScoreCalculation) return;
            this.summary.querySelector("[data-text]").innerText = `Trustscore ${this.businessUnit.score.trustScore} | ${this.businessUnit.numberOfReviews.usedForTrustScoreCalculation} reviews`;
        }
        fetchReviews() {
            fetch(`https://api.trustpilot.com/v1/business-units/${this.businessUnit.id}/reviews?apikey=${this.apiKey}&perPage=${this.pageLimit}&language=${this.locale}${this.tagValue}${this.orderBy}`).then((response)=>response.text()).then((responseText)=>{
                const responseObject = JSON.parse(responseText);
                if (!responseObject.reviews) return error;
                this.displayReviews(responseObject.reviews);
            }).catch((error1)=>this.errorHandler(error1));
        }
        displayReviews(reviews) {
            reviews.forEach((review)=>{
                this.review = this.template.content.cloneNode(true);
                const stars = this.renderStars(review.stars);
                this.review.querySelector("[data-stars]").innerHTML = stars;
                this.review.querySelector("[data-title]").innerText = review.title;
                this.review.querySelector("[data-text]").innerText = review.text;
                this.reviewList.append(this.review);
            });
            if (reviews.length || Shopify.designMode) this.hidden = false;
            if (!reviews.length && Shopify.designMode) this.ShopifyDesignMode();
        }
        renderStars(rating) {
            return [
                ...Array(rating)
            ].map((star)=>'<span class="star">&#9733;</span>').join("");
        }
        errorHandler(error1) {
            if (!error1) error1 = "Unknown error";
            console.error("An error has occured", error1);
        }
        ShopifyDesignMode() {
            // TODO
            this.innerHTML = '<p style="text-align: center;">No reviews found</p>';
        }
    }
    customElements.define("trustpilot-business-reviews", TruspilotBusinessReviews);
}



})();
